module.exports = __webpack_public_path__ + "6ade8c7fdb59ae6551828c13c00a0c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quit-mask1.png
// module id = 1313
// module chunks = 61